export const bookingExcelConfig = {
  fileName: 'Booking_List',
  sheetName: 'Bookings',
  columns: [
    { header: 'Booking ID', key: 'id' }, // ✅ same as formatter
    { header: 'Requirement', key: 'requirement' },
    { header: 'Meals', key: 'meals' },

    { header: 'Start Date', key: 'startDate' },
    { header: 'Start Time', key: 'startTime' },
    { header: 'End Time', key: 'endTime' },

    { header: 'Customer Name', key: 'customerName' },
    { header: 'Venue Address', key: 'venueAddress' },
    { header: 'Billing Address', key: 'billingAddress' },

    { header: 'Head Count', key: 'headCount' },
    { header: 'Chef Fare', key: 'chefFare' },

    { header: 'Chef Rating', key:'chefRating'},
    { header: 'Cleaner Fare', key: 'cleanerFare' },
    { header: 'Chef ID', key:'chefId'},
    { header: 'Chef Name', key:'chef'},

    { header: 'Total Amount', key: 'totalAmount' },

    { header: 'Status', key: 'status' },
    { header: 'Created At', key: 'createdAt' },
  ],
};